<template>
  <div>
    <ui-spinner v-if="loading.view"></ui-spinner>
    <div v-else class="mt-3">
      <p class="text-capitalize">Mes: {{ $dayjs(month, "YYYY-MM").format("MMMM") }}</p>
      <p>Guías:</p>
      <div class="table-responsive">
        <table class="table table-bordered table-hover" style="table-layout: fixed">
          <thead class="table-secondary">
            <tr>
              <td style="width: 200px;">Nombre</td>
              <td
                v-for="item in containers.numDays"
                :key="item"
                class="text-center"
                :class="{
                  'table-warning': containers.sundays.includes(item),
                }"
                style="
                  width: 30px;
                  padding-left: 2px;
                  padding-right: 2px;
                  white-space: nowrap;
                "
              >
                {{ item }}
              </td>
              <td style="width: 180px;">Acciones</td>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!containers.programados.length">
              <td><!-- nombre --></td>
              <td v-for="item in containers.numDays" :key="item"></td>
              <td><!-- acciones --></td>
            </tr>
            <ProgramarGuiaComponent
              v-for="item in containers.programados"
              :key="item.idGuia"
              :item="item"
              :numDays="containers.numDays"
              :sundays="containers.sundays"
              :idModule="idModule"
              :month="month"
              @save="onSave"
              @delete="onDelete"
            />
            <tr>
              <td>
                <InputSelect :options="guiasFiltered" label="nombre" :reduce="(opt) => opt.idPersona" v-model="fd.idGuia"> </InputSelect>
              </td>
              <td :colspan="2 + containers.numDays">
                <button class="btn btn-sm btn-light-success" @click="addGuia"><i class="fa fa-fw fa-plus"></i> Agregar</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <hr />
      <p>Calendario:</p>
      <ProgramarCalendarioComponent
        :startWeekDay="containers.startWeekDay"
        :sundays="containers.sundays"
        :numDays="containers.numDays"
        :guias="guiasForCalendar"
        :month="month"
        :idModule="idModule"
        :calendario="containers.calendario"
      />
    </div>
  </div>
</template>
<script>
import InputSelect from "../../../modules/shared/components/InputSelect.vue";
import ProgramarGuiaComponent from "@/views/programacion/guias/ProgramarGuiaComponent";
import ProgramarCalendarioComponent from "@/views/programacion/guias/ProgramarCalendarioComponent";
export default {
  props: {
    month: String,
    idModule: Number,
  },
  components: {
    ProgramarGuiaComponent,
    ProgramarCalendarioComponent,
    InputSelect,
  },
  data() {
    return {
      fd: {
        idGuia: null,
      },
      loading: {
        view: true,
      },
      containers: {
        programados: [],
        calendario: [],
        guias: [],
        numDays: null,
        startWeekDay: null,
        sundays: [],
      },
    };
  },
  created() {
    const vm = this;

    vm.axios
      .get("/programacion/guias", {
        params: {
          month: vm.month,
          idModule: vm.idModule,
        },
      })
      .then((response) => {
        vm.containers.guias = response.data.content.guias;

        const programados = response.data.content.programados;

        programados.forEach((item) => {
          item.diasTrabajo = item.diasTrabajo ? JSON.parse(item.diasTrabajo) : [];
        });

        vm.containers.programados = programados;

        const calendario = response.data.content.calendario;

        calendario.forEach((item) => {
          item.guiasNombres = item.guiasNombres ? JSON.parse(item.guiasNombres) : [];
        });

        vm.containers.calendario = calendario;

        let momentMonth = vm.$dayjs(vm.month, "YYYY-MM");
        vm.containers.numDays = momentMonth.daysInMonth();

        let firstNextSunday = Number(momentMonth.day(7).format("D"));
        let sundays = firstNextSunday > 7 ? [1] : [];

        for (let i = firstNextSunday; i <= 31; i += 7) {
          sundays.push(i);
        }

        let startWeekDay = momentMonth.startOf("month").day();
        startWeekDay = startWeekDay == 0 ? 7 : startWeekDay;
        startWeekDay = startWeekDay - 1;
        vm.containers.startWeekDay = startWeekDay;
        vm.containers.sundays = sundays;
        vm.loading.view = false;
      })
      .catch((error) => {});
  },
  computed: {
    guiasFiltered() {
      const vm = this;
      const programados = vm.containers.programados.map((item) => item.idGuia);
      return vm.containers.guias.filter((item) => !programados.includes(item.idPersona));
    },
    guiasForCalendar() {
      return this.containers.programados.filter((item) => item.idGuiaFechasLibres > 0);
    },
  },
  methods: {
    addGuia() {
      const vm = this;
      if (!vm.fd.idGuia) {
        return vm.$swal.fire("", "Selecciona un guía.", "warning");
      }
      let guia = vm.containers.guias.find((item) => item.idPersona == vm.fd.idGuia);

      vm.fd.idGuia = null;

      vm.containers.programados.push({
        diasTrabajo: [],
        guia: guia.nombre,
        idGuia: guia.idPersona,
        idGuiaFechasLibres: -new Date().getTime(),
      });
    },
    onSave(pId, pDays) {
      const vm = this;
      vm.containers.programados.find((item) => item.idGuiaFechasLibres == pId).diasTrabajo = pDays;
      console.log("onSave", pDays);
    },
    onDelete(pId) {
      const vm = this;
      vm.containers.programados = vm.containers.programados.filter((item) => item.idGuiaFechasLibres !== pId);
    },
  },
};
</script>
